import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

import { useColorMode } from '../theme/ColorModeContext';

/**
 * App-bar icon button that toggles light/dark color mode.
 *
 * Matches the sibling app-bar icon buttons (`color="primary"`,
 * `size="medium"`) so it introduces no visual size change. Shows a moon
 * (Brightness4) in light mode (→ switch to dark) and a sun (Brightness7)
 * in dark mode (→ switch to light).
 */
const ColorModeToggle: React.FC = () => {
  const { mode, toggle } = useColorMode();
  const isLight = mode === 'light';

  return (
    <Tooltip title={isLight ? 'Dark mode' : 'Light mode'}>
      <IconButton
        aria-label="Toggle dark mode"
        color="primary"
        size="medium"
        onClick={toggle}
      >
        {isLight ? <Brightness4Icon /> : <Brightness7Icon />}
      </IconButton>
    </Tooltip>
  );
};

export default ColorModeToggle;
